import QuranScheduleDateUserModel from '../Apis/QuranScheduleDateUser'
import Controller from './Controller'

export default class QuranScheduleDateUserController extends Controller {
  constructor() {
    super(new QuranScheduleDateUserModel())
  }

  async GetTeacherSchedules(params) {
   return await this.model.GetTeacherSchedules(params)
  }

  async GetTeachersOptions() {
    return await this.model.GetTeachersOptions()
  }
  
  async GetTeacherStudents(params) {
    return await this.model.GetTeacherStudents(params)
  }
}
